var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorOl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V0.975262H0.5H1V3.41342V3.90105H2V3.41342V0H0.5H0ZM5 0.975262V2.92579H20V0.975262H5ZM0 5.85157V6.82683H0.5H1.79297L0 8.57545V9.75262H2.5H3V8.77736H2.5H1.20703L3 7.02874V5.85157H0.5H0ZM5 6.82683V8.77736H20V6.82683H5ZM0 11.7031V12.6784H0.5H2V13.166H1.5H1V14.1413H1.5H2V14.6289H0.5H0V15.6042H0.5H3V14.1413V13.166V11.7031H0.5H0ZM5 12.6784V14.6289H20V12.6784H5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorOl);
export default __webpack_public_path__ + "static/media/icon_editor_ol.81f480bc69d04d557ebc27cb95ec02e5.svg";
export { ForwardRef as ReactComponent };